<mat-card appearance="outlined">
  <h3>Statische Ausgaben</h3>
  <div class="products">
    <div *ngIf="hasIbexinfo && !tokens?.length" class="product">
      <div [style.background-image]="'url(/assets/img/logos/ibex-info.png)'"></div>
      <mat-icon>settings</mat-icon>
    </div>
    <div (click)="login(token)" *ngFor="let token of tokens" class="product">
      <div [style.background-image]="'url(' + token.logo + '?t=132456789)'"></div>
      <mat-icon>settings</mat-icon>
    </div>
  </div>
  <div class="buttons">
    <div *ngIf="tokens?.length" class="button" (click)="login(tokens[0])">{{'dashboard.login' | translate}}</div>
    <div *ngIf="hasIbexinfo &&!tokens?.length" class="button" (click)="openConfigInfo('content')">{{'dashboard.writeData' | translate}}</div>
  </div>
</mat-card>
